import React, { useState } from "react";
import "./NewsEvents.scss";
import { IoMdTime } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import NewsImage from "../../assets/NewsImages/Graduation/graduationMain.jpg";
import AdmissionModal from "../AdmissionComponents/AdmissionModal/AdmissionModal";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const NewsEvents = () => {
  const [admissionModal, setAdmissionModal] = useState(false);
  const eventsList = [
    {
      day: "05",
      month: "March",
      title: "Cultural Diversity Day (Celebration of Ghana’s 67th Independence Day)",
      time:"8:00am"
    },
    {
      day: "11",
      month: "March",
      title: "Parent – Facilitator Conference (PFC) & Book Fair",
      time: "8:00am"
    },
    {
      day: "12",
      month: "March",
      title: "Book Character Day ",
      time:"8:00am"
    },
    {
      day: "13",
      month: "March",
      title: "Anell Arts & Exhibition",
      time:"8:00am"	
    },
    {
      day: "20",
      month: "March",
      title: "World Oral Day",
      time:"8:00am"	
    },
  ];
  useEffect(() => {
    if (admissionModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  });
  return (
    <div className="news-events">
      <div className="news-events-header">
        <h1>News & Events</h1>
        <div className="bottom">
          <Link to={"/news-events/news"} className="read-all-news">Read All News</Link>
          <div className="underline"></div>
        </div>
      </div>
      <div className="content">
        <div className="news">
          <div className="news-content">
            <img src={NewsImage} alt="medical screening" />
            <p>29th SEPTEMBER, 2023 / GRADUATION CEREMONY</p>
            <Link to={"/news-events/news/2023-graduation-ceremony/"} className="news-caption">
              The second edition of the school’s graduation
              where learners from the Foundation Class,Reception 2 and Grade 3
              Class were graduated to the next higher class.
            </Link>
          </div>
        </div>
        <div className="events">
          <div className="events-content">
            <div className="title">
              <h3>Upcoming Events</h3>
              <div className="bar"></div>
            </div>
            <div className="event-list">
              {eventsList.map((event, index) => (
                <div key={index} className="event-item">
                  <div className="date">
                    <h3 className="day">{event.day}</h3>
                    <h3 className="month">{event.month}</h3>
                    <div className="date-underline"></div>
                  </div>
                  <div className="event-details">
                    <div className="event-title">
                      <h3>{event.title}</h3>
                    </div>
                    <div className="time-venue">
                      <div className="time">
                        <IoMdTime />
                        {event.time}
                      </div>
                      <div className="venue">
                        <FaLocationDot />
                        School Premise
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="admission-apply">
          <div className="admission-content">
            <h2 className="apply-title">Apply For Admission</h2>
            {admissionModal && (
              <AdmissionModal
                admissionModal={admissionModal}
                setAdmissionModal={setAdmissionModal}
              />
            )}
            <div
              className="classic-button"
              onClick={() => setAdmissionModal(!admissionModal)}
            >
              Apply Now
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsEvents;
